export default [
  {
    _tag: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/',
    icon: 'cil-speedometer',
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['Politics']
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Canada',
    route: '/political/canada',
    icon: 'cil-x-circle',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'Federal',
        to: '/political/canada/federal/',
        exact: false
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Provincial',
        to: '/political/canada/provincial/',
        exact: false
      }      
    ]
  },
]

